import type { AppDefinition } from '../../types/apps';

export const PromptsAppV2Definition: AppDefinition = {
  appId: 'prompts-v2',
  name: 'Prompt',
  version: '1.0.0',
  description: 'Write, edit, and run AI prompts with version history',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'PaperPlaneTilt',
    phosphorWeight: 'duotone',
  },
  entityIcons: {
    Prompt: {
      type: 'phosphor',
      phosphorIcon: 'PaperPlaneTilt',
      phosphorWeight: 'duotone',
      color: '#6366f1',
    },
  },
  entityTypes: ['Prompt'],
  component: 'prompts-v2',
  requiresProps: false,
  // No entity required — the app shows a home screen listing all prompts when
  // opened without one, and navigates in-place to a prompt when selected.
  requiresEntity: false,
  actions: {},
};
